import { render, staticRenderFns } from "./private-policy.vue?vue&type=template&id=07d1b2cf&scoped=true"
import script from "./private-policy.vue?vue&type=script&lang=js"
export * from "./private-policy.vue?vue&type=script&lang=js"
import style0 from "./private-policy.vue?vue&type=style&index=0&id=07d1b2cf&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d1b2cf",
  null
  
)

export default component.exports